import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { WalletProvider } from "./context/WalletContext";
import { Toaster } from "./components/ui/sonner";
import { StarField } from "./components/StarField";
import { AgeGate } from "./components/AgeGate";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Directory from "./pages/Directory";
import ExpertProfile from "./pages/ExpertProfile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Credits from "./pages/Credits";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import ChatRoom from "./pages/ChatRoom";
import ConsultantDashboard from "./pages/ConsultantDashboard";
import ExpertDashboard from "./pages/ExpertDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Assistance from "./pages/Assistance";
import { AuthCallback } from "./pages/AuthCallback";
import { CommentCaMarche, Tarifs, FaqPage } from "./pages/Content";
import { CGU, Confidentialite, MentionsLegales } from "./pages/Legal";

function Shell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experts" element={<Directory />} />
        <Route path="/experts/:id" element={<ExpertProfile />} />
        <Route path="/connexion" element={<Login />} />
        <Route path="/inscription" element={<Register />} />
        <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/credits" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
        <Route path="/assistance" element={<ProtectedRoute><Assistance /></ProtectedRoute>} />
        <Route path="/chat/:id" element={<ProtectedRoute><ChatRoom /></ProtectedRoute>} />
        <Route path="/tableau-de-bord" element={<ProtectedRoute roles={["consultant"]}><ConsultantDashboard /></ProtectedRoute>} />
        <Route path="/expert" element={<ProtectedRoute roles={["expert"]}><ExpertDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <WalletProvider>
            <StarField />
            <AgeGate />
            <Toaster position="top-center" richColors theme="dark" />
            <Shell />
          </WalletProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
